import IHLogoLarge from "src/images/logos/inhouse-logo-large.png";

const SharedPageTopNav = () => {
  return (
    <div className="fixed top-0 w-full md:static h-[80px] pl-0 md:pl-0 justify-center md:justify-start shadow-sm md:!shadow-none bg-[#FDFBF8] flex items-center  px-[32px] py-[16px] z-[2] mx-4">
      <a href="https://www.inhouse.ai/" target="_blank" rel="noopener">
        <img src={IHLogoLarge} className="w-[90px] h-[38px] object-contain cursor-pointer" alt="Inhouse" />
      </a>
    </div>
  );
};

export default SharedPageTopNav;
